import { atom } from "nanostores"
import type { Href } from "expo-router"

const ONBOARDING_SCREENS: Href[] = [
  "/login",
  "/register",
  "/confirm",
  "/reset",
  "/google",
  "/reset-password",
  "/account",
  "/softcreditpull",
  "/softcreditpull/confirmation",
  "/",
]

export const $originalUrlBeforeLoginRedirect = atom<Href | null>(null)

export const setOriginalUrlBeforeLoginRedirect = (url: Href | null) => {
  if (
    url &&
    !ONBOARDING_SCREENS.includes(url) &&
    !(url as string).startsWith?.("/pre-qual")
  ) {
    console.log("Setting redirect to ", url)
    $originalUrlBeforeLoginRedirect.set(url)
  }
}
